var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('img',{staticClass:"shareimg",attrs:{"src":require("../../assets/img/shareimg.png"),"alt":""}}),_c('div',{staticClass:"shareFixed"},[_c('van-button',{staticStyle:{"font-size":"20px"},attrs:{"block":""},on:{"click":_vm.back}},[_vm._v("点击了解 立享8折优惠")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }